<template>
  <ListView
    modelName="Component"
    perm="master.menu_component"
    :items.sync="items"
    :params.sync="params"
    title="menu_component"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="Component"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    :comparer="(a,b)=>a.id == b.id"    
    tooltip="セット品マスタ・構成品マスタを使用して構成数量を登録すると、【在庫一覧】のセット品組立・セット品分解や【受注一覧】の発注処理で構成品発注を実施できるようになります。セット品と構成品は事前に商品マスタやSKUマスタにも登録しておく必要があります。予備項目(商品識別情報)の指定も可能です。"        
    :popup="popup"  
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.id }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.assembly.name }}</GridItem>
    <!-- <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.componentCommodity.code }}</GridItem>     -->
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.componentCommodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.componentQuantity }}</GridItem>
    <!-- <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.divideReferencePrice }}</GridItem> -->
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.reserveText1 }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.reserveText2 }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.reserveText3 }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.reserveText4 }}</GridItem>
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.reserveText5 }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.reserveText6 }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.reserveMemo1 }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.reserveMemo2 }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.reserveMemo3 }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.reserveDate1 | date }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.reserveDate2 | date }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.reserveDate3 | date }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.reserveList1 | category_41 }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.reserveList2 | category_42 }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.reserveList3 | category_43 }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView">
        <ListViewMenu slot="file_layout_download" icon="file_download" title="インポートファイル"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E6%A7%8B%E6%88%90%E5%93%81%E3%83%9E%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="構成品インポート用のレイアウトファイルをダウンロードします。" />
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <!-- <FilterBox title="構成品商品コード" :value.sync="params.commodityCode" @click="handler" /> -->
        <!-- <FilterBox title="構成品商品名称" :value.sync="params.commodityName" @click="handler" />                 -->
        <!-- <FilterBox title="セット品名称" :value.sync="params.assemblyName" @click="handler" /> -->
        <AutoComplete title="セット品" :value.sync="params.assembly" query="AssemblyMasterQuery" @changed="handler"/>
        <AtcCommodity title="構成品商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="構成品SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />                
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />          
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />        
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','予備項目','ワークフロー','更新履歴']" :tabTooltips="[null,null,null,null]">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="workflowRequired(item)" :enabled="workflowRequired(item)" :nullValue="0" /> -->
              <NumericBox title="ID" :value.sync="item.id" :editor="editor" :enabled="false" tooltip="構成品を管理するためのID(自動採番)が表示されます。"/>
              <AutoComplete title="セット品" :value.sync="item.assembly" :editor="editor" query="AssemblyMasterQuery" :required="true" :enabled="listView.isInsertMode && popup ==null"  :isLink="true" @linkClicked="onLinkClicked(item.assembly)" tooltip="【セット品一覧】に登録したセット品を指定します。<br>※1度確定すると変更できません。"/>
              <AtcCommodity title="構成品商品" :value.sync="item.componentCommodity" :editor="editor" :required="true" :linkOnNewTab="false" :enabled="isEditable(item)" tooltip="【商品一覧】に登録した構成品を指定します。<br>※1度確定すると変更できません。" />
              <AtcSKU title="構成品SKU" :value.sync="item.sku" :editor="editor" :commodity="item.componentCommodity" :enabled="isEditable(item)" tooltip="【SKU一覧】に登録した構成品SKUを指定します。<br>※1度確定すると変更できません。" />
              <NumericBox title="構成数量" :value.sync="item.componentQuantity" :editor="editor" :enabled="isEditable(item)" decimals="3" more="0" max="99999999.999" :nullValue="0" tooltip="セット品1単位に必要な構成品の数量を指定します。<br>※1度確定すると変更できません。" />
              <!-- <NumericBox title="分解基準単価" :value.sync="item.divideReferencePrice" :editor="editor" :enabled="isEditable(item)" decimals="6" more="0" max="99999999999.999999" :nullValue="0" /> -->
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">

              <!-- <TextBox title="状態" :value="item.state | masterBaseStatus" :editor="editor" :enabled="false" />
              <TextBox title="所有者" :value="item.holder | user" :editor="editor" :enabled="false" />
              <TextBox title="初回保存日" :value="item.initialSavedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="初回保存者" :value="item.initialSavedBy | user" :editor="editor" :enabled="false" />
              <TextBox title="最終更新日" :value="item.lastUpdatedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="最終更新者" :value="item.lastUpdatedBy | user" :editor="editor" :enabled="false" /> -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="最後に更新した日付が表示されます。" />                      
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ登録用のワークフローを指定します。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="現在のワークフローの状態が表示されています。" />                  
            </template>
          </EditPanel>
        </template>
        <!-- 予備項目タブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="isEditable(item)" :commodityAttribute="visibleTypes.Editable" :stockAttribute="visibleTypes.None"  :orderMemo="visibleTypes.None" :deliveryMemo="visibleTypes.None" :commodity="item.commodity" /> 
        </template>        
        <!-- ワークフロータブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab3" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ComponentView extends Vue {
  public items: Common.Component[] = new Array(0);
  public params: Common.ComponentQuery = new Common.ComponentQuery();
  public importQuery = new Common.ImportQuery('構成品', 'Component');
  public exportQuery = new Common.ExportQuery('構成品', this.params);
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;  

  @Prop() public auditNo:string;
  @Prop() public assemblyId:number;
  @Prop() public assembly:Common.Assembly;  
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public inputType:Common.InputTypes = Common.InputTypes.Order;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'assembly', text:'セット品' },
    { value: 'componentCommodity', text:'構成品商品' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  //一覧項目可変プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public listGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([], 0, 'grid');

  public created() {
    this.tenantSettings = this.$api.tenantSettings;

    // 予備項目表示の可変対応
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('ID', 100),
      new Common.GridItemConfiguration('セット品', 150),
      // new Common.GridItemConfiguration('構成品商品コード', 150),      
      new Common.GridItemConfiguration('構成品商品', 150),
      new Common.GridItemConfiguration('構成品SKU', 150),
      new Common.GridItemConfiguration('構成数量', 150),
      // new Common.GridItemConfiguration('分解基準単価', 180),
    );
    this.listGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,false,false));
    this.listGridConfig.setGridItems(
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),      
    );        
    this.listCaptions =this.listGridConfig.gridCaptions;
    this.listWidths = this.listGridConfig.gridWidths;
    this.listSlots = this.listGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }

    if (this.assemblyId){
      this.params.assemblyId = this.assemblyId;
    } else if (this.assembly)    {
      this.params.assembly = this.assembly;
    }
    if(!this.auditNo && !this.assemblyId){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  
  public async onCreate(obj: Common.Component) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.assembly)obj.assembly = this.assembly;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Component):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Component):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public onLinkClicked(item: Common.Assembly){
      this.$router.push(String.format('/master/Assembly?id={0}', item.id));         
  }
  
}
</script>
